// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@keyframes zoomIn {
    from {
        transform: scale(0.5);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.zoom-in-animation {
    animation: zoomIn 1s ease-in-out forwards;
}

.fortune-detail-container {
    /*background: linear-gradient(to right, #ff7e5f, #feb47b); !* Gradient background *!*/
    padding: 20px; /* Padding for better spacing */
}
.level-title {
    font-size: 1.0rem; /* 글자 크기 */
    font-weight: bold; /* 두꺼운 글씨 */
    color: 'black';
    text-shadow:
            1px 1px 2px rgba(255, 215, 0, 0.7),  /* 약간의 그림자 */
            0 0 25px rgba(255, 215, 0, 0.5), /* 빛나는 효과 */
            0 0 5px rgba(255, 215, 0, 0.5); /* 더욱 밝은 빛 */
    margin-bottom: 15px; /* 아래쪽 여백 */
    animation: glow 1.5s infinite alternate; /* 빛나는 효과 */
}

/* 빛나는 효과 애니메이션 */
@keyframes glow {
    0% {
        text-shadow:
                0 0 5px #FFD700,
                0 0 10px #FFD700,
                0 0 15px #FFD700,
                0 0 20px #FFD700;
    }
    100% {
        text-shadow:
                0 0 10px #FFD700,
                0 0 20px #FFD700,
                0 0 30px #FFD700,
                0 0 40px #FFD700;
    }
}

.card {
    background: rgba(255, 255, 255, 0.8); /* Semi-transparent card background */
    border: none; /* Remove border */
    border-radius: 10px; /* Rounded corners for the card */
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); /* Soft shadow for depth */
}

.fortune-detail-container {
    padding: 2rem;
    max-width: 450px;
    margin: auto;
}



.character-image {
    width: 100%;
    height: 150px;
}

.score-section {
    width: 100%;
    margin-top: 1rem;
}

.score {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
}

.score-bar {
    width: 80%;
    height: 8px;
    border-radius: 5px;
}

.score-icon {
    margin-left: 0.5rem;
}

.description {
    background-color: #282c34; /* 다크 모드 배경색 */
    color: #abb2bf; /* 코딩 스타일의 글자색 */
    padding: 1rem;
    border-radius: 8px;
    font-family: 'Courier New', Courier, monospace; /* 코딩 스타일 폰트 */
    font-size: 0.9rem;
    line-height: 1.5;
    overflow-wrap: break-word;
    margin-bottom: 1.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 약간의 그림자 */
}

.description::before {
    content: "/* 오늘의 Tip❗❗*/";
    display: block;
    color: #5c6370; /* 주석 스타일 */
    margin-bottom: 0.5rem;
}

.description span {
    color: #98c379; /* 강조 텍스트 색상 */
}

.description .code-line {
    display: block;
    position: relative;
}

.description .code-line::before {
    content: attr(data-line-number); /* 줄 번호 표시 */
    position: absolute;
    left: -2rem;
    width: 1.5rem;
    color: #5c6370;
    text-align: right;
    margin-right: 0.5rem;
}

.likes-card {
    background-color: #f8f9fa;
    font-size: 0.9rem;
    color: #333;
}

.likes-item {
    font-weight: bold;
}

.recommend-section {
    text-align: center;
}

.recommend-image {
    width: 80px;
    height: auto;
}

.recommend-text {
    font-weight: bold;
    margin-top: 0.5rem;
    color: #333;
}

.recommend-caption {
    font-size: 0.8rem;
    color: #888;
    margin-top: 0.3rem;
}

.custom-button {
    width: 100%;
    font-size: 0.9rem;
    font-weight: bold;
}

.share-icons {
    display: flex;
    justify-content: center;
    gap: 1rem;
    font-size: 1.5rem;
}

.share-test-button {
    background-color: #333;
    color: white;
    width: 100%;
    padding: 0.8rem;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/component/luckyDetail.css"],"names":[],"mappings":";AACA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,qFAAqF;IACrF,aAAa,EAAE,+BAA+B;AAClD;AACA;IACI,iBAAiB,EAAE,UAAU;IAC7B,iBAAiB,EAAE,WAAW;IAC9B,cAAc;IACd;;;0CAGsC,EAAE,YAAY;IACpD,mBAAmB,EAAE,WAAW;IAChC,uCAAuC,EAAE,WAAW;AACxD;;AAEA,iBAAiB;AACjB;IACI;QACI;;;;gCAIwB;IAC5B;IACA;QACI;;;;gCAIwB;IAC5B;AACJ;;AAEA;IACI,oCAAoC,EAAE,qCAAqC;IAC3E,YAAY,EAAE,kBAAkB;IAChC,mBAAmB,EAAE,iCAAiC;IACtD,yCAAyC,EAAE,0BAA0B;AACzE;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;;;AAIA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,cAAc;IACzC,cAAc,EAAE,gBAAgB;IAChC,aAAa;IACb,kBAAkB;IAClB,8CAA8C,EAAE,cAAc;IAC9D,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC,EAAE,YAAY;AAC1D;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,cAAc,EAAE,WAAW;IAC3B,qBAAqB;AACzB;;AAEA;IACI,cAAc,EAAE,cAAc;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,+BAA+B,EAAE,YAAY;IAC7C,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB","sourcesContent":["\r\n@keyframes zoomIn {\r\n    from {\r\n        transform: scale(0.5);\r\n        opacity: 0;\r\n    }\r\n    to {\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.zoom-in-animation {\r\n    animation: zoomIn 1s ease-in-out forwards;\r\n}\r\n\r\n.fortune-detail-container {\r\n    /*background: linear-gradient(to right, #ff7e5f, #feb47b); !* Gradient background *!*/\r\n    padding: 20px; /* Padding for better spacing */\r\n}\r\n.level-title {\r\n    font-size: 1.0rem; /* 글자 크기 */\r\n    font-weight: bold; /* 두꺼운 글씨 */\r\n    color: 'black';\r\n    text-shadow:\r\n            1px 1px 2px rgba(255, 215, 0, 0.7),  /* 약간의 그림자 */\r\n            0 0 25px rgba(255, 215, 0, 0.5), /* 빛나는 효과 */\r\n            0 0 5px rgba(255, 215, 0, 0.5); /* 더욱 밝은 빛 */\r\n    margin-bottom: 15px; /* 아래쪽 여백 */\r\n    animation: glow 1.5s infinite alternate; /* 빛나는 효과 */\r\n}\r\n\r\n/* 빛나는 효과 애니메이션 */\r\n@keyframes glow {\r\n    0% {\r\n        text-shadow:\r\n                0 0 5px #FFD700,\r\n                0 0 10px #FFD700,\r\n                0 0 15px #FFD700,\r\n                0 0 20px #FFD700;\r\n    }\r\n    100% {\r\n        text-shadow:\r\n                0 0 10px #FFD700,\r\n                0 0 20px #FFD700,\r\n                0 0 30px #FFD700,\r\n                0 0 40px #FFD700;\r\n    }\r\n}\r\n\r\n.card {\r\n    background: rgba(255, 255, 255, 0.8); /* Semi-transparent card background */\r\n    border: none; /* Remove border */\r\n    border-radius: 10px; /* Rounded corners for the card */\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); /* Soft shadow for depth */\r\n}\r\n\r\n.fortune-detail-container {\r\n    padding: 2rem;\r\n    max-width: 450px;\r\n    margin: auto;\r\n}\r\n\r\n\r\n\r\n.character-image {\r\n    width: 100%;\r\n    height: 150px;\r\n}\r\n\r\n.score-section {\r\n    width: 100%;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.score {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.score-bar {\r\n    width: 80%;\r\n    height: 8px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.score-icon {\r\n    margin-left: 0.5rem;\r\n}\r\n\r\n.description {\r\n    background-color: #282c34; /* 다크 모드 배경색 */\r\n    color: #abb2bf; /* 코딩 스타일의 글자색 */\r\n    padding: 1rem;\r\n    border-radius: 8px;\r\n    font-family: 'Courier New', Courier, monospace; /* 코딩 스타일 폰트 */\r\n    font-size: 0.9rem;\r\n    line-height: 1.5;\r\n    overflow-wrap: break-word;\r\n    margin-bottom: 1.5rem;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 약간의 그림자 */\r\n}\r\n\r\n.description::before {\r\n    content: \"/* 오늘의 Tip❗❗*/\";\r\n    display: block;\r\n    color: #5c6370; /* 주석 스타일 */\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.description span {\r\n    color: #98c379; /* 강조 텍스트 색상 */\r\n}\r\n\r\n.description .code-line {\r\n    display: block;\r\n    position: relative;\r\n}\r\n\r\n.description .code-line::before {\r\n    content: attr(data-line-number); /* 줄 번호 표시 */\r\n    position: absolute;\r\n    left: -2rem;\r\n    width: 1.5rem;\r\n    color: #5c6370;\r\n    text-align: right;\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.likes-card {\r\n    background-color: #f8f9fa;\r\n    font-size: 0.9rem;\r\n    color: #333;\r\n}\r\n\r\n.likes-item {\r\n    font-weight: bold;\r\n}\r\n\r\n.recommend-section {\r\n    text-align: center;\r\n}\r\n\r\n.recommend-image {\r\n    width: 80px;\r\n    height: auto;\r\n}\r\n\r\n.recommend-text {\r\n    font-weight: bold;\r\n    margin-top: 0.5rem;\r\n    color: #333;\r\n}\r\n\r\n.recommend-caption {\r\n    font-size: 0.8rem;\r\n    color: #888;\r\n    margin-top: 0.3rem;\r\n}\r\n\r\n.custom-button {\r\n    width: 100%;\r\n    font-size: 0.9rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.share-icons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 1rem;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.share-test-button {\r\n    background-color: #333;\r\n    color: white;\r\n    width: 100%;\r\n    padding: 0.8rem;\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
